import { render, staticRenderFns } from "./DMarketView.vue?vue&type=template&id=43bbe8c2"
import script from "./DMarketView.vue?vue&type=script&lang=js"
export * from "./DMarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports